import axios from 'axios'

let HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}

if (!!localStorage.token) {
    HEADERS['Authorization'] = 'Token ' + localStorage.getItem('token')
}

export default axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
    withCredentials: true,
    headers: HEADERS,
})


// WEBPACK FOOTER //
// ./src/utils/request.js